import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { getIsClientAdmin } from 'containers/Auth/utils';

export const is2FAExcluded = ({
  auth,
  clientDetails,
  mfaExcludedUsersConfig,
  profile,
}) => {
  const mfaWhitelistConfig = _get(mfaExcludedUsersConfig, 'config', {});
  const excludedFirebaseIds = _get(mfaWhitelistConfig, 'firebaseIds', []);
  const clientsInclude = _get(mfaWhitelistConfig, 'clientsInclude', []);
  const clientsExclude = _get(mfaWhitelistConfig, 'clientsExclude', []);
  // Only enable whitelist if explicitly configured as enabled and there are IDs to exclude
  const isWhitelistEnabled =
    _get(mfaWhitelistConfig, 'enabled', false) &&
    !_isEmpty(excludedFirebaseIds);

  const currentFirebaseId = _get(auth, 'uid');
  const clientShortName = _get(clientDetails, 'shortName');
  const clientGroupShortName = _get(clientDetails, 'clientGroup.shortName');

  // Check if user is an internal admin (admin, contentAdmin, or clientAdmin)
  const isInternalAdmin =
    _get(profile, 'role') === 'admin' ||
    _get(profile, 'role') === 'contentAdmin' ||
    getIsClientAdmin(profile, clientDetails);

  // Check if whitelist is enabled for current brand
  let isWhitelistEnabledForBrand = false;
  if (isWhitelistEnabled) {
    // Check if brand is explicitly excluded
    const isBrandExcluded =
      !_isEmpty(clientsExclude) &&
      (clientsExclude.includes(clientShortName) ||
        clientsExclude.includes(clientGroupShortName));

    // If clientsInclude has entries, check if this brand is included
    if (!_isEmpty(clientsInclude)) {
      isWhitelistEnabledForBrand =
        !isBrandExcluded &&
        (clientsInclude.includes(clientShortName) ||
          clientsInclude.includes(clientGroupShortName));
    } else {
      // If no inclusion list, whitelist applies to all brands (unless excluded)
      isWhitelistEnabledForBrand = !isBrandExcluded;
    }
  }

  return (
    isWhitelistEnabledForBrand &&
    isInternalAdmin &&
    excludedFirebaseIds.includes(currentFirebaseId)
  );
};
